import { makeStyles } from "@material-ui/core"

import { colors } from "@/styles/colors"
import ColorUtil from "@/utils/ColorUtil"

const useStyles = makeStyles(theme => ({
	breadcrumb: {
		display: "flex",
		alignItems: "center"
	},
	logoImg: {
		maxHeight: 50
	},
	chatTabs: {
		position: "relative",
		"&::before": {
			content: "close-quote",
			position: "absolute",
			width: "100%",
			height: "1px",
			bottom: 0,
			left: 0,
			...ColorUtil.getBackgroundAndContrastColor(colors.gray[200])
		}
	},
	chatTab: {
		color: `${colors.gray[700]} !important`,
		opacity: 1,
		fontSize: 14
	},
	chatTabIndicator: {
		...ColorUtil.getBackgroundAndContrastColor(colors.getPrimaryColor())
	},
	explanationLink: {
		cursor: "pointer"
	},
	explanationText: {
		color: colors.gray[500]
	},
	categoryTitle: {
		color: colors.gray[500]
	},
	tipsContainer: {
		...ColorUtil.getBackgroundAndContrastColor(colors.gray[0]),
		borderRadius: theme.spacing(0.5),
		padding: theme.spacing(1.5, 2)
	},
	tipsIcon: {
		fontSize: "1rem",
		marginBottom: "3px"
	},
	tipsHeaderText: {
		fontSize: theme.spacing(1.5),
		color: colors.getPrimaryColor(),
		fontWeight: 500
	},
	tipsTitleText: {
		fontSize: theme.spacing(1.75),
		fontWeight: 500,
		color: colors.gray[700]
	},
	tipsContentText: {
		fontSize: theme.spacing(1.5),
		color: colors.gray[600],
		fontWeight: 400
	}
}))

export default useStyles
